// extracted by mini-css-extract-plugin
export var statItem = "_io-1";
export var statsRow = "_io-0";